import Phaser from 'phaser';

export class ParticleEffects {
  static initTextures(scene: Phaser.Scene) {
    if (!scene.textures.exists('particle_star')) {
      const g = scene.add.graphics();
      g.fillStyle(0xffd700, 1);
      g.fillCircle(4, 4, 4);
      g.generateTexture('particle_star', 8, 8);
      g.destroy();
    }
    if (!scene.textures.exists('particle_confetti')) {
      const g = scene.add.graphics();
      g.fillStyle(0xffffff, 1);
      g.fillRect(0, 0, 8, 8);
      g.generateTexture('particle_confetti', 8, 8);
      g.destroy();
    }
    if (!scene.textures.exists('particle_ray')) {
      const g = scene.add.graphics();
      g.fillStyle(0xffffff, 1);
      g.fillRect(0, 0, 100, 4);
      g.generateTexture('particle_ray', 100, 4);
      g.destroy();
    }
  }

  static sparkleAtPoint(scene: Phaser.Scene, x: number, y: number) {
    this.initTextures(scene);
    const emitter = scene.add.particles(x, y, 'particle_star', {
      speed: { min: 50, max: 150 },
      scale: { start: 1, end: 0 },
      alpha: { start: 1, end: 0 },
      lifespan: 800,
      blendMode: 'ADD',
      quantity: 20
    });
    emitter.explode(20);
    scene.time.delayedCall(1000, () => emitter.destroy());
  }

  static confettiBurst(scene: Phaser.Scene) {
    this.initTextures(scene);
    const width = scene.scale.width;
    const height = scene.scale.height;
    
    const colors = [0xff0000, 0x00ff00, 0x0000ff, 0xffff00, 0xff00ff, 0x00ffff];
    
    colors.forEach((color) => {
      const emitter = scene.add.particles(width / 2, height / 2, 'particle_confetti', {
        speed: { min: 200, max: 600 },
        angle: { min: 0, max: 360 },
        scale: { start: 1, end: 0.5 },
        alpha: { start: 1, end: 0 },
        tint: color,
        lifespan: 2000,
        gravityY: 400
      });
      emitter.explode(40);
      scene.time.delayedCall(2500, () => emitter.destroy());
    });
  }

  static coinBurst(scene: Phaser.Scene, x: number, y: number, count: number) {
    this.initTextures(scene);
    const emitter = scene.add.particles(x, y, 'particle_star', {
      speed: { min: 100, max: 300 },
      angle: { min: 200, max: 340 },
      scale: { start: 1.5, end: 0.5 },
      tint: 0xffd700,
      gravityY: 500,
      lifespan: 1500
    });
    emitter.explode(count);
    scene.time.delayedCall(2000, () => emitter.destroy());
  }

  static levelUpRays(scene: Phaser.Scene, x: number, y: number) {
    this.initTextures(scene);
    const emitter = scene.add.particles(x, y, 'particle_ray', {
      speed: 100,
      scaleX: { start: 0, end: 2 },
      scaleY: { start: 1, end: 0 },
      alpha: { start: 0.5, end: 0 },
      rotate: { min: 0, max: 360 },
      blendMode: 'ADD',
      lifespan: 1000
    });
    emitter.explode(10);
    scene.time.delayedCall(1500, () => emitter.destroy());
  }
}
